var rich_content_viewer_default = {
  "fontElementMap": "U9pPC",
  "wrapper": "wf7mH",
  "pluginContainerMobile": "_71-mD",
  "viewer": "r3a7X",
  "android": "U880X",
  "rootedTraversedContent": "EPigl",
  "atomic": "_97DO-",
  "toolbar": "yYn91",
  "block": "kMs5L"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
